import {CountryUtils} from './CountryUtils';

export class CropUtils {

    static get crop () {

        return _.transform(CropUtils.CROPS, (result, uuid, crop) => {
            result[uuid] = {
                uuid,
                cropKey: crop,
                color: CropUtils.color[uuid],
                dfIcon: CropUtils.dfIcon[crop],
                priority: CropUtils.priority[crop],
                cropSeasonLength: CropUtils.cropSeasonLength[crop]
            };
        }, {});
    }

    // TODO: move priorities to the crop configuration service
    static get priority () {

        return {
            WINTER_WHEAT: 1,
            DURUM_WHEAT: 2,
            SPRING_WHEAT: 10,
            SOYBEAN: 9,
            POTATO: 6,
            SUGAR_BEET: 7,
            WINTER_BARLEY: 3,
            OILSEED_RAPE: 5,
            CORN: 8,
            CANOLA: 4,
            RICE: 11,
            WINTER_RYE: 12
        };
    }

    static get dfIcon () {

        return {
            WINTER_WHEAT: 'wheat',
            DURUM_WHEAT: 'wheat',
            SPRING_WHEAT: 'wheat',
            SUGAR_BEET: 'sugar-beet',
            POTATO: 'potato',
            OILSEED_RAPE: 'oilseed-rape',
            WINTER_BARLEY: 'barley',
            CANOLA: 'oilseed-rape',
            CORN: 'corn',
            SOYBEAN: 'soybean',
            RICE: 'rice',
            UNASSIGNED: 'sun-field',
            WINTER_RYE: 'rye',

            OATS: 'oats',
            SUNFLOWERS:	'sunflower',
            MONKEYNUT: 'monkey-nut',
            BROMUS_CATHARTICUS: 'bromus-catharticus',
            BRASSICA_RAPA: 'brassica-rapa',
            CHICKPEA: 'chickpea',
            DACTYLIS_GLOMERATA: 'dactylis-glomerata',
            GOSSYPIUM_HIRSUTUM: 'gossypium-hirsutum',
            LENTILS: 'lentils',
            FLAX: 'flax',
            LOLIUM_PERENNE: 'lolium-perenne',
            LOTUS_CORNICULATUS: 'lotus-corniculatus',
            ALFALFA: 'alfalfa',
            MELILOTUS_ALBUS: 'melilotus-albus',
            PANICUM_MILIACEUM: 'panicum-miliaceum',
            DRY_BEANS: 'dry-beans',
            PEAS: 'peas',
            SORGHUM_SP: 'sorghum-sp',
            TRIFOLIUM_PRATENSE: 'trifolium-pratense',
            TRIFOLIUM_REPENS: 'trifolium-repens',
            THINOPYRUM_ELONGATUM: 'thinopyrum-elongatum',
            CHLORIS_GAYANA: 'chloris-gayana',
            ERAGROSTIS_CURVULA: 'eragrostis-curvula',
            SCHEDONORUS_ARUNDINACEUS: 'schedonorus-arundinaceus',
            LOLIUM_MULTIFLORUM: 'lolium-multiflorum',
            LOTUS_GLABER: 'lotus-glaber',
            UROCHLOA_MAXIMA: 'urochloa-maxima',
            PASPALUM_DILATATUM: 'paspalum-dilatatum',
            SACCHARUM_HYBRIDS: 'saccharum-hybrids',
            VICIA_SP: 'vicia-sp',
            GRASSLAND: 'grassland',
            FOXTAIL_MILLET: 'foxtail-millet',
            WINTER_TRITICALE: 'winter-triticale',
            SPRING_BARLEY: 'barley',
            SPRING_DURUM_WHEAT: 'wheat',
            BROADBEAKED_MUSTARD: 'crop',
            OIL_SQUASH: 'crop',
            ONION: 'crop',
            LEEK: 'crop',
            CARROT: 'crop',
            SPRING_RYE: 'rye',
            TRITICUM_SPELTA: 'crop',
            SPRING_TRITICALE: 'winter-triticale',
            WINTER_OAT: 'oats',
            SPRING_OIL_SEED_RAPE: 'oilseed-rape',
            MUSTARD_SEED: 'crop',
            SORGHUM: 'sorghum-sp',
            RYE: 'rye',
            BUCK_WHEAT: 'wheat',
            HEMP: 'crop',
            COMMON_SUGARCANE: 'sugar',
            FODDER_BEET: 'sugar-beet',
            BROAD_BEANS: 'beans',
            COMMON_CORIANDER: 'crop'
        };
    }

    // TODO uniform with other configs
    // copied from FieldsLayout/TimelineView/TimelineView.less
    static get color () {

        return {
            '387f0de8-2015-96d2-86cf-f8d7b7151c6c': '#EDA425', // soya
            '9b4ee6b2-ae2d-6c9a-af77-08a4b749031f': '#58A555', // winterwheat
            '0dc6b6d6-4566-4966-3dcf-4f23722e7832': '#58A555', // durumwheat
            'd6762313-1841-b6a0-dcb1-a94ab311618a': '#58A555', // springwheat
            'ec0d0f52-dd71-ebb9-0a39-831768fe4490': '#8ABB55', // winterbarley
            '5299afb0-37fd-6ad5-4d1f-65f9668799b9': '#91502E', // potato
            '619287cf-c63f-78b5-f563-56342ee09ec2': '#BAC225', // oilseedrape
            '21486538-1018-3545-1b27-eef605e51e7f': '#BAC225', // oilseedrape
            '6c119c74-41ec-8bc5-1b0f-15ff3a913bc0': '#AB5E2E', // sugarbeet
            'b59fc4c2-7738-ec26-6925-d3041e155180': '#EABA10', // corn
            'e54c5e22-94a0-a5ff-34a6-4fe0f8ad1ccc': '#FFFFFF', // rice
        };
    }

    static get cropSeasonLength () {

        return {
            WHEAT: 330,
            SOYBEAN: 180,
            POTATO: 230,
            SUGAR_BEET: 230,
            WINTER_BARLEY: 330,
            OILSEED_RAPE: 330,
            RICE: 180
        };
    }

    // crop uuid => cropseason length
    static getCropSeasonLengthByUuid (uuid) {

        if(CropUtils.crop[uuid]){
            return CropUtils.crop[uuid].cropSeasonLength;
        } else {
            return 180;
        }
    }

    // @TODO: Do this using crop country configuration
    static checkForPestRisks (selectedFsm) {

        if (selectedFsm && selectedFsm.length) {

            let cs = _.head(selectedFsm).get('cropSeason');
            let cropUuid = cs ? cs.get('cropUuid') : undefined;

            return (cropUuid === CropUtils.CROPS.OILSEED_RAPE);
        }
    }

    // crop uuid => crop protection 
    static getCropProtection (uuid) {

        let cropSpecificProtection = {
            '619287cf-c63f-78b5-f563-56342ee09ec2': __('INSECTICIDE')
        };

        if (cropSpecificProtection[uuid]) {
            return cropSpecificProtection[uuid];
        } else {
            return __('FUNGICIDE');
        }
    }

    static checkIfZoneSprayFeatureIsSupported (cropUuid, country) {

        let zoneSprayFeature = CountryUtils.getSupportedFeatures(country).zoneSprayFeature;

        if (!zoneSprayFeature) {
            return false;
        }

        return _.includes(zoneSprayFeature, cropUuid);
    }

    static get CROPS () {

        return {

            WINTER_WHEAT: '9b4ee6b2-ae2d-6c9a-af77-08a4b749031f',
            DURUM_WHEAT: '0dc6b6d6-4566-4966-3dcf-4f23722e7832',
            SPRING_WHEAT: 'd6762313-1841-b6a0-dcb1-a94ab311618a',
            SUGAR_BEET: '6c119c74-41ec-8bc5-1b0f-15ff3a913bc0',
            POTATO: '5299afb0-37fd-6ad5-4d1f-65f9668799b9',
            OILSEED_RAPE: '619287cf-c63f-78b5-f563-56342ee09ec2',
            WINTER_BARLEY: 'ec0d0f52-dd71-ebb9-0a39-831768fe4490',
            CANOLA: '21486538-1018-3545-1b27-eef605e51e7f',
            CORN: 'b59fc4c2-7738-ec26-6925-d3041e155180',
            RICE: 'e54c5e22-94a0-a5ff-34a6-4fe0f8ad1ccc',
            SOYBEAN: '387f0de8-2015-96d2-86cf-f8d7b7151c6c',
            WINTER_RYE: '5c8bb7ea-5b9a-aa5a-2f11-7fdccfc713aa',

            // Non Timing
            OATS: 'f2970e40-01b4-339d-3de7-5b19f7393703',
            SUNFLOWERS:	'd086e9f3-ad1c-af18-b8cd-411be5db670b',
            MONKEYNUT: 'a7ca1b71-f1ba-ab55-441c-982f00b2b236',
            BROMUS_CATHARTICUS: '648bfb5b-ce85-f713-7a08-ca8e7c73400e',
            BRASSICA_RAPA: '93d6102c-6f26-646f-3212-24fd150ba94c',
            CHICKPEA: '95ee42ed-c0f8-8551-02c8-f5806b616fce',
            DACTYLIS_GLOMERATA: '38c1d1af-dd99-b283-09e6-220368322cf1',
            GOSSYPIUM_HIRSUTUM: 'f3cba8d9-b818-3ec7-f147-36a332bb30d9',
            LENTILS: 'f2cf30e8-462e-9811-2aab-20c285d605da',
            FLAX: '0ca9b456-f2de-1486-8378-f9643e63413c',
            LOLIUM_PERENNE: '3fe403eb-0775-fc97-c758-b81ab60c0b95',
            LOTUS_CORNICULATUS: '69759c1e-a3fd-556c-43ec-1bb88ac9d1f4',
            ALFALFA: 'b5a17c7c-aed7-6c05-5e05-224f6390f6e4',
            MELILOTUS_ALBUS: '20032981-bf50-ef16-4da6-58d284d0883d',
            PANICUM_MILIACEUM: '01381ee4-a3f3-e710-690a-e775ac5156e8',
            DRY_BEANS: 'd672cb81-5a86-9177-e412-e8507d1fbc9e',
            PEAS: '0f78171b-b01c-ff3d-2a0f-6c3c4191fcfc',
            SORGHUM_SP: '83cb386e-8e5a-7110-2344-c222a3bd77db',
            TRIFOLIUM_PRATENSE: '1d98d02e-0ae9-9926-5a4c-4152afae5513',
            TRIFOLIUM_REPENS: 'ff3d116c-288c-6b47-1322-d9170f7a14c3',
            THINOPYRUM_ELONGATUM: '625b1e7f-615b-4ab3-4cbc-46f577eb89d5',
            CHLORIS_GAYANA: '18d04cf7-421c-ca1f-aed1-dce2ce74e063',
            ERAGROSTIS_CURVULA: 'c11298f9-ff3e-4a67-17d0-0284edcd133d',
            SCHEDONORUS_ARUNDINACEUS: '21e24834-6d4a-d25f-8447-277c42029328',
            LOLIUM_MULTIFLORUM: '3ddb27f7-7377-f4c4-546b-43035e560510',
            LOTUS_GLABER: '35f297de-8dc3-b509-16e9-28a9b69d29e7',
            UROCHLOA_MAXIMA: '0aaa4e8a-db78-c2e8-bf91-ec8805c2dc8b',
            PASPALUM_DILATATUM: '72182a28-b377-203b-10b8-d79787f518ef',
            SACCHARUM_HYBRIDS: '4e409a36-1ca1-ae12-e3e8-91d0f5fd45e1',
            VICIA_SP: '4f7a84be-bf4c-6231-23a5-ac598e0ad985',
            GRASSLAND: '201fbf47-ad3e-3fb9-18b1-de7221ad0ddb',
            FOXTAIL_MILLET: 'dc4670e4-38c9-f5a1-035a-3642cde4d28d',
            WINTER_TRITICALE: '6dbe1df0-11b1-e502-0a3f-1cba5668b02b',
            SPRING_BARLEY: '24197977-623a-6514-d080-3aa170896771',
            SPRING_DURUM_WHEAT: '75844767-cd96-247f-fe97-8025a593caba',
            BROADBEAKED_MUSTARD: '9b1c4b9d-4b2a-4413-42eb-6714262ea2bf',
            OIL_SQUASH: 'e56d6dcf-62f3-b4b7-8736-a06f7f14742e',
            ONION: '754b282d-1b4f-ff98-5a02-c99ea4bd4a93',
            LEEK: '16d8c3a2-9158-686d-f604-ce015a5a9f32',
            CARROT: 'a7117f18-8c3e-0f79-2e74-52f76459db73',
            SPRING_RYE: '2cb3a999-98d8-c3eb-9d1b-a2cc99c1c17d',
            TRITICUM_SPELTA: 'd65fb3b9-faef-7913-c0b5-8629df1bcaa9',
            SPRING_TRITICALE: '859696c5-e133-42a6-d9d4-1fea8610c718',
            WINTER_OAT: '132f12e8-fa52-4e31-7a00-f86eb641a81c',
            SPRING_OIL_SEED_RAPE: 'caf6eb4d-79d3-0761-5fb2-9fec2d6b9aa1',
            MUSTARD_SEED: '9abaf7d8-c0c5-a524-5aeb-73158ded1637',
            SORGHUM: '4c1002b5-d6eb-576a-da99-12df5448dca1',
            RYE: '988e0c6d-f264-0b92-c724-4cc3921504ed',
            BUCK_WHEAT: '418ad89b-e582-3321-bfe5-1ad9b0a0f1c8',
            HEMP: '7fee4284-113a-3b24-7084-4b905cfc4820',
            COMMON_SUGARCANE: '2635d6e9-b581-a717-cf9b-51ad86f443cf',
            FODDER_BEET: 'b1e7feb0-7f5f-9501-f4a1-07913146090b',
            BROAD_BEANS: '9888aece-8c38-3d93-baf0-fc4420853b4d',
            COMMON_CORIANDER: 'e93d8150-33e9-168a-0a4d-1a87f98f487b'
        };
    }

    static get CROP_UUIDS () {

        return _.invert(CropUtils.CROPS);
    }

    static getTypeNames (crops) {
        
        const uuidTypeDic = this.CROP_UUIDS;

        const typeNameDic = {};

        crops.forEach((crop) => {
            const {
                uuid,
                name,
            } = crop.attributes;

            if(uuidTypeDic[uuid]) {
                typeNameDic[uuidTypeDic[uuid]] = name;
            }
        });

        return typeNameDic;
    }

    static get CROPS_SUPPORTED_ONESOIL () {

        return {
            WINTER_WHEAT: '9b4ee6b2-ae2d-6c9a-af77-08a4b749031f',
            DURUM_WHEAT: '0dc6b6d6-4566-4966-3dcf-4f23722e7832',
            SPRING_WHEAT: 'd6762313-1841-b6a0-dcb1-a94ab311618a',
            SUGAR_BEET: '6c119c74-41ec-8bc5-1b0f-15ff3a913bc0',
            POTATO: '5299afb0-37fd-6ad5-4d1f-65f9668799b9',
            OILSEED_RAPE: '619287cf-c63f-78b5-f563-56342ee09ec2',
            WINTER_BARLEY: 'ec0d0f52-dd71-ebb9-0a39-831768fe4490',
            CANOLA: '21486538-1018-3545-1b27-eef605e51e7f',
            CORN: 'b59fc4c2-7738-ec26-6925-d3041e155180',
            SOYBEAN: '387f0de8-2015-96d2-86cf-f8d7b7151c6c',
            RICE: 'e54c5e22-94a0-a5ff-34a6-4fe0f8ad1ccc',
            SUNFLOWERS:	'd086e9f3-ad1c-af18-b8cd-411be5db670b',
            WINTER_RYE: '5c8bb7ea-5b9a-aa5a-2f11-7fdccfc713aa',

            // Commenting since they are not supported by backend
            /*OATS: 'f2970e40-01b4-339d-3de7-5b19f7393703',
            RAPE: '2615acdb-2ce7-1844-5c6e-02b7e90b8c2d',
            WINTER_BARLEY2: '9adae8d2-a46b-2e9d-7629-d8f9e934fd1e',
            CASSAVA: '501ca9cf-71b0-096d-350a-fba5839fe785',
            COTTON: 'a63d59b2-02ba-6116-e660-64393fa5d9e1',
            OILSEED_RAPE_CANOLA: 'f6951172-eef0-eeb8-3f25-ee8842990d46',
            SORGHUM_SP: '4c1002b5-d6eb-576a-da99-12df5448dca1',
            WHEAT: '7f550f58-15b9-261f-cbc0-5bf6e44821be',
            DURUM_WHEAT_SPRING: '75844767-cd96-247f-fe97-8025a593caba',
            WHEAT2: '227f26a4-f6e3-11b1-233b-5a09e76e2887',*/

            ALFALFA: 'b5a17c7c-aed7-6c05-5e05-224f6390f6e4',
            BROMUS_CATHARTICUS: '648bfb5b-ce85-f713-7a08-ca8e7c73400e',
            DACTYLIS_GLOMERATA :'38c1d1af-dd99-b283-09e6-220368322cf1',
            DRY_BEANS :'d672cb81-5a86-9177-e412-e8507d1fbc9e',
            FLAX :'0ca9b456-f2de-1486-8378-f9643e63413c',
            GOSSYPIUM_HIRSUTUM :'f3cba8d9-b818-3ec7-f147-36a332bb30d9',
            LENTILS :'f2cf30e8-462e-9811-2aab-20c285d605da',
            LOTUS_CORNICULATUS :'69759c1e-a3fd-556c-43ec-1bb88ac9d1f4',
            SCHEDONORUS_ARUNDINACEUS :'21e24834-6d4a-d25f-8447-277c42029328',
            TRIFOLIUM_PRATENSE :'1d98d02e-0ae9-9926-5a4c-4152afae5513',
            SORGHUM :'4c1002b5-d6eb-576a-da99-12df5448dca1',
            VICIA_SP :'4f7a84be-bf4c-6231-23a5-ac598e0ad985',
            PEAS :'0f78171b-b01c-ff3d-2a0f-6c3c4191fcfc',
            MONKEYNUT :'a7ca1b71-f1ba-ab55-441c-982f00b2b236',
            RYE :'988e0c6d-f264-0b92-c724-4cc3921504ed',
            WINTER_TRITICALE: '6dbe1df0-11b1-e502-0a3f-1cba5668b02b',
            SPRING_TRITICALE: '859696c5-e133-42a6-d9d4-1fea8610c718'
        };
    }


    /**
     * @description This method returns the crops of all the fsms for adding observations.
     *
     */
    static checkObservationIsEnabled (cropCollection, countryCode) {

        if(cropCollection) {

            let filteredCrops = cropCollection.filter(function (crop) {

                switch (countryCode) {
                    case CountryUtils.COUNTRY.GERMANY:
                        return crop.get('uuid') !== CropUtils.CROPS.CORN;
                    case CountryUtils.COUNTRY.ARGENTINA:
                        return crop.get('uuid') !== CropUtils.CROPS.CORN && crop.get('uuid') !== CropUtils.CROPS.SOYBEAN;
                    case CountryUtils.COUNTRY.BRAZIL:
                        return crop.get('uuid') !== CropUtils.CROPS.SOYBEAN;
                    default:
                        return cropCollection;
                }
            });

            return filteredCrops;
        }
    }

    static checkVarietyForKwsSupport (varietyUuid) {

        const supportedVarietyUuids = [
            "b6953881-0cdf-b401-2664-9743183b575a",
            "7bdabea1-4220-f434-cf74-6beda7e4e7f2",
            "b726e4cb-a834-4447-cf8a-f57f9e5ffa9b",
            "9bf02778-174f-5bff-5061-090f07c08d91",
            "182997f2-9a7d-6d00-1404-0c443f219e4b",
            "6419e05e-384e-4562-25c1-fc538060391c",
            "60a7f24e-d863-5b8d-4c82-a239001ced50",
            "c70f9e4d-5642-ebb6-e86d-d6e723db5e1e",
            "63ef155f-511d-297c-b882-0e6a1303372b",
            "24be3f27-a175-a5bc-c4b1-324e9bda073b",
            "eb8673c0-ecc8-3482-1dc0-6312bc9b2b91",
            "a5734957-b715-e66c-2e36-d643fd7af44c",
            "66e04d74-d6be-5f75-6de8-d58a1590f748",
            "f4da388d-f7a0-0f90-05b2-a16fa794cdf8",
            "abf539c4-03ae-994e-7cde-ede9da044d30",
            "212cce6e-6252-1978-ea1e-a91bb58f271e",
            "a6827cd8-2595-a017-9793-414609d3c02c",
            "adf20ff5-4ff9-6e4c-c1c3-3c39c2992fcf",
            "4437cdcd-d0fa-4523-2a56-9f335721a11c",
            "ce13bcdd-09dd-7bc1-7cd8-a92f56e66488",
            "89b6009f-8d0d-b0a9-6f7d-4a4ee921c819",
            "b6e9bdb9-9bfd-4ee3-0ad0-6cf3052d5f22",
            "b17ebac8-9161-641a-bd12-6b8f4fdf26b3",
            "c6a69555-90f0-010e-08fb-05a34c0f7121",
            "3ed450d8-fed1-429a-f7f2-277f950f21b6",
            "a3d44316-586c-0568-dbfe-10305f5fc3ea",
            "b300d87b-bc08-363d-4f2a-0849f1915746",
            "e38aa6fe-acf4-aea6-0c6e-fa881da141d4",
            "2076dfc8-2d57-af63-7a82-abec4f111439",
            "40cd7865-b734-8526-dc2d-81ef9bfa29cd",
            "89d69658-619d-2350-7758-bc5b81b8ed69",
            "ad31368a-f2c6-f9ab-dfe9-d556f7d2743d",
            "c7a7264c-508a-71aa-73d2-43f02ef43f13",
            "f4603ca1-c0e8-63d5-0888-a1a062e5e4f3",
            "d7a5ee0c-dfb9-b998-735d-c920754a9064",
            "cfac6381-4737-43ff-e105-5e8a5a4c7e87",
            "1208bcee-0f27-6db7-9210-fd78fa5961b3",
            "9b66381e-b0cf-7c3e-58fc-0e28d567e6c7",
            "70a3cf82-6fbd-2fdb-101f-8ca6b57aa43d",
            "16c7f73a-f717-83ff-773b-60506b4f7b42",
            "0d845686-825b-8c84-d781-e32f45768daa",
            "5e938c9b-ab22-6145-2ea5-82f50b7e7773",
            "33fda81b-a6ad-d5cb-851e-a82b958fabd4",
            "d3a2ea5a-c981-a048-6bea-3f2b8c5b8110",
            "035274db-ede4-9927-ebe0-19f0d7ad1a56",
            "9193a409-4dc1-24f8-ffbe-94a05dd21f64",
            "05392879-86f5-d139-e9ed-1e39022e80b1",
            "3ba35d25-3dcb-ff96-b6e6-2a061ebed2d5",
            "bf3b874e-f587-112d-f31c-e7d1031e07b6",
            "d167f823-7d60-a208-323f-c8354d82e32d",
            "160b59bb-a60b-a93e-1e0d-2d0d80252f56",
            "8c49b21b-b06d-5dd1-f6a4-a66771403534"
        ];

        return supportedVarietyUuids.includes(varietyUuid);

    }

}


// WEBPACK FOOTER //
// ./shared/utils/CropUtils.js